import {
  Component,
  OnInit,
  Input,
  inject,
} from '@angular/core';
import { Router } from '@angular/router';
import { NavService } from '../../../../../services/nav.service';
import { TablerIconsModule } from 'angular-tabler-icons';
import { CommonModule, NgForOf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { CoreService } from 'src/app/services/core.service';
import { PatientService } from 'src/app/services/patient.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavItem } from '../../../vertical/sidebar/nav-item/nav-item';

@Component({
  selector: 'app-horizontal-nav-item',
  standalone: true,
  imports: [TablerIconsModule, CommonModule, MatIconModule, NgForOf],
  templateUrl: './nav-item.component.html',
})
export class AppHorizontalNavItemComponent implements OnInit {
  @Input() depth: any;
  @Input() item: any;
  snackBar = inject(MatSnackBar);

  constructor(public navService: NavService, public router: Router, public settings: CoreService, public patientService: PatientService) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnInit() {}
  onItemSelected(item: any) {
    if (!item.children || !item.children.length) {
      console.log('/' + this.settings.getPortalType() + item.route);
      if (item.dontCheckPatientSelection) {
        this.router.navigate(['/' + this.settings.getPortalType() + '/' + item.route]);
      } else {
        if(!this.patientService.getSelectedPatient()) {
          this.snackBar.open('Seleziona un paziente per accedere a questa funzionalità', 'Chiudi', {
            duration: 3000,
            verticalPosition: 'top'
          });
        } else {
          this.router.navigate(['/' + this.settings.getPortalType() + '/' + this.patientService.getSelectedPatient().ehrId + item.route]);
        }
      }
    }
  }

  getItemPath(item: NavItem): string {
    if (this.patientService?.getSelectedPatient()?.ehrId) {
      return `${this.settings.getPortalType()}/${this.patientService?.getSelectedPatient()?.ehrId}${item.route}`;
    } else {
      return `${this.settings.getPortalType()}${item.route}`;
    }
  }
}
